import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { TitleComponent } from '../../primitives/title/title.component';
import { SimpleButtonComponent } from '../../primitives/simple-button/simple-button.component';
import { ButtonComponent } from "../../primitives/button/button.component";

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TitleComponent, SimpleButtonComponent, ButtonComponent]
})
export class ContentHeaderComponent {
  @Input() title: string | undefined = undefined;
  @Input() large: boolean = false;
  @Input() padded: boolean = false;
  @Input() action: string | undefined = undefined;

  public actionClick = output<void>();

  actionClicked() {
    this.actionClick.emit();
  }

}